
<div class="card sq-card">
    <div class="card-header card-header-squirrel">
        <h4>{{this.translate.data['GROUPROLEUSERS'] | translate}}</h4>
        {{groupRoleName}}
    </div>
    <div class="card-body">
        <div class="group-role-user-tables" style="max-height:300px; overflow-y:auto;">
            <div class="example-loading-shade" *ngIf="isLoadingResults || isRateLimitReached">
                <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
                <div class="example-rate-limit-reached" *ngIf="isRateLimitReached">
                    Squirrel's API rate limit has been reached. It will be reset in one minute.
                </div>
            </div>
            <ag-grid-angular  style="width:400px; height:100%; padding: 5px;" 
            class="ag-theme-balham"
            [overlayLoadingTemplate]="overlayLoadingTemplate"
            [domLayout]="'autoHeight'"
            [gridOptions]="gridOptions" 
            (gridReady)="onGridReady($event)" 
            [frameworkComponents]="frameworkComponents">
            </ag-grid-angular>
        </div>
        <div class="row button-right">
            <!-- <button matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}" mat-button  (click)="cancel()">
                <mat-icon>close</mat-icon>
            </button> -->
                <a>
                    <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-right: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
                                    (click)="cancel()" >Schließen</button>
                </a>                   
            <!-- <span style="flex: 1 1 auto"></span> -->
                    <!-- <button matTooltip="{{this.translate.data['TOOLTIPADDUSER'] | translate}}" mat-button (click)="openUserGroupRoleDialog()">
                <mat-icon>person_add</mat-icon>
            </button> -->
            
            <!-- <span style="flex: 1 1 auto"></span> -->
        </div>      
    </div>
</div>